import { render, staticRenderFns } from "./EditScormLesson.vue?vue&type=template&id=38583cc8"
import script from "./EditScormLesson.vue?vue&type=script&lang=js"
export * from "./EditScormLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports